// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/white_pool.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum tracker.v1.CampaignWhiteState
 */
export enum CampaignWhiteState {
  /**
   * @generated from enum value: CAMPAIGN_WHITE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The campaign was made without a pool white.
   *
   * @generated from enum value: CAMPAIGN_WHITE_STATE_NONE = 1;
   */
  NONE = 1,

  /**
   * It holds lander_id; its protection rules point at it.
   *
   * @generated from enum value: CAMPAIGN_WHITE_STATE_ASSIGNED = 2;
   */
  ASSIGNED = 2,

  /**
   * It waits for its white («white готовится»); ActivateCampaign refuses
   * white_pending, and it starts itself when the white arrives if it was
   * created ACTIVE. After a replacement found the cell empty the burned
   * white (lander_id) keeps serving until the new one arrives.
   *
   * @generated from enum value: CAMPAIGN_WHITE_STATE_PENDING = 3;
   */
  PENDING = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(CampaignWhiteState)
proto3.util.setEnumType(CampaignWhiteState, "tracker.v1.CampaignWhiteState", [
  { no: 0, name: "CAMPAIGN_WHITE_STATE_UNSPECIFIED" },
  { no: 1, name: "CAMPAIGN_WHITE_STATE_NONE" },
  { no: 2, name: "CAMPAIGN_WHITE_STATE_ASSIGNED" },
  { no: 3, name: "CAMPAIGN_WHITE_STATE_PENDING" },
]);

/**
 * @generated from enum tracker.v1.WhiteCellColor
 */
export enum WhiteCellColor {
  /**
   * @generated from enum value: WHITE_CELL_COLOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Tomorrow's need is covered.
   *
   * @generated from enum value: WHITE_CELL_COLOR_ENOUGH = 1;
   */
  ENOUGH = 1,

  /**
   * Above the threshold, below the target.
   *
   * @generated from enum value: WHITE_CELL_COLOR_TIGHT = 2;
   */
  TIGHT = 2,

  /**
   * At or below the threshold with nothing ordered.
   *
   * @generated from enum value: WHITE_CELL_COLOR_LOW = 3;
   */
  LOW = 3,

  /**
   * Below the target with an order on the way.
   *
   * @generated from enum value: WHITE_CELL_COLOR_ORDERED = 4;
   */
  ORDERED = 4,

  /**
   * The cell or its category is switched off.
   *
   * @generated from enum value: WHITE_CELL_COLOR_OFF = 5;
   */
  OFF = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(WhiteCellColor)
proto3.util.setEnumType(WhiteCellColor, "tracker.v1.WhiteCellColor", [
  { no: 0, name: "WHITE_CELL_COLOR_UNSPECIFIED" },
  { no: 1, name: "WHITE_CELL_COLOR_ENOUGH" },
  { no: 2, name: "WHITE_CELL_COLOR_TIGHT" },
  { no: 3, name: "WHITE_CELL_COLOR_LOW" },
  { no: 4, name: "WHITE_CELL_COLOR_ORDERED" },
  { no: 5, name: "WHITE_CELL_COLOR_OFF" },
]);

/**
 * @generated from enum tracker.v1.WhiteState
 */
export enum WhiteState {
  /**
   * @generated from enum value: WHITE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WHITE_STATE_FRESH = 1;
   */
  FRESH = 1,

  /**
   * @generated from enum value: WHITE_STATE_ASSIGNED = 2;
   */
  ASSIGNED = 2,

  /**
   * @generated from enum value: WHITE_STATE_BURNED = 3;
   */
  BURNED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(WhiteState)
proto3.util.setEnumType(WhiteState, "tracker.v1.WhiteState", [
  { no: 0, name: "WHITE_STATE_UNSPECIFIED" },
  { no: 1, name: "WHITE_STATE_FRESH" },
  { no: 2, name: "WHITE_STATE_ASSIGNED" },
  { no: 3, name: "WHITE_STATE_BURNED" },
]);

/**
 * @generated from enum tracker.v1.WhiteRefillKind
 */
export enum WhiteRefillKind {
  /**
   * @generated from enum value: WHITE_REFILL_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 02:00 Europe/Kyiv: up to the target.
   *
   * @generated from enum value: WHITE_REFILL_KIND_NIGHT = 1;
   */
  NIGHT = 1,

  /**
   * During the day: fresh ≤ threshold.
   *
   * @generated from enum value: WHITE_REFILL_KIND_THRESHOLD = 2;
   */
  THRESHOLD = 2,

  /**
   * A campaign found its cell empty: one site, PRIORITY_URGENT.
   *
   * @generated from enum value: WHITE_REFILL_KIND_URGENT = 3;
   */
  URGENT = 3,

  /**
   * An admin's «Пополнить сейчас».
   *
   * @generated from enum value: WHITE_REFILL_KIND_MANUAL = 4;
   */
  MANUAL = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(WhiteRefillKind)
proto3.util.setEnumType(WhiteRefillKind, "tracker.v1.WhiteRefillKind", [
  { no: 0, name: "WHITE_REFILL_KIND_UNSPECIFIED" },
  { no: 1, name: "WHITE_REFILL_KIND_NIGHT" },
  { no: 2, name: "WHITE_REFILL_KIND_THRESHOLD" },
  { no: 3, name: "WHITE_REFILL_KIND_URGENT" },
  { no: 4, name: "WHITE_REFILL_KIND_MANUAL" },
]);

/**
 * @generated from enum tracker.v1.WhiteRefillState
 */
export enum WhiteRefillState {
  /**
   * @generated from enum value: WHITE_REFILL_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Written, not yet acknowledged by the port.
   *
   * @generated from enum value: WHITE_REFILL_STATE_CREATING = 1;
   */
  CREATING = 1,

  /**
   * @generated from enum value: WHITE_REFILL_STATE_OPEN = 2;
   */
  OPEN = 2,

  /**
   * @generated from enum value: WHITE_REFILL_STATE_DONE = 3;
   */
  DONE = 3,

  /**
   * @generated from enum value: WHITE_REFILL_STATE_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: WHITE_REFILL_STATE_CANCELLED = 5;
   */
  CANCELLED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(WhiteRefillState)
proto3.util.setEnumType(WhiteRefillState, "tracker.v1.WhiteRefillState", [
  { no: 0, name: "WHITE_REFILL_STATE_UNSPECIFIED" },
  { no: 1, name: "WHITE_REFILL_STATE_CREATING" },
  { no: 2, name: "WHITE_REFILL_STATE_OPEN" },
  { no: 3, name: "WHITE_REFILL_STATE_DONE" },
  { no: 4, name: "WHITE_REFILL_STATE_FAILED" },
  { no: 5, name: "WHITE_REFILL_STATE_CANCELLED" },
]);

/**
 * WhiteAssignment asks CreateCampaign for an automatic white.
 *
 * @generated from message tracker.v1.WhiteAssignment
 */
export class WhiteAssignment extends Message<WhiteAssignment> {
  /**
   * Take a white from the pool. false = the campaign gets none.
   *
   * @generated from field: bool auto = 1;
   */
  auto = false;

  /**
   * The white category; "" = the one category the campaign's offers' tags
   * map to (else white_category_required).
   *
   * @generated from field: string category_key = 2;
   */
  categoryKey = "";

  /**
   * ISO 3166-1 alpha-2; "" = the one country of the campaign's
   * COUNTRY_NOT_IN rule, else the one country its offers share.
   *
   * @generated from field: string geo = 3;
   */
  geo = "";

  /**
   * BCP 47; "" = the language of the campaign's first page that names one,
   * else the only cell of category × geo.
   *
   * @generated from field: string lang = 4;
   */
  lang = "";

  constructor(data?: PartialMessage<WhiteAssignment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.WhiteAssignment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auto", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "category_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "geo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WhiteAssignment {
    return new WhiteAssignment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WhiteAssignment {
    return new WhiteAssignment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WhiteAssignment {
    return new WhiteAssignment().fromJsonString(jsonString, options);
  }

  static equals(a: WhiteAssignment | PlainMessage<WhiteAssignment> | undefined, b: WhiteAssignment | PlainMessage<WhiteAssignment> | undefined): boolean {
    return proto3.util.equals(WhiteAssignment, a, b);
  }
}

/**
 * CampaignWhite is a campaign's white, read-only for the cabinet.
 *
 * @generated from message tracker.v1.CampaignWhite
 */
export class CampaignWhite extends Message<CampaignWhite> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * @generated from field: tracker.v1.CampaignWhiteState state = 2;
   */
  state = CampaignWhiteState.UNSPECIFIED;

  /**
   * The white serving now ("" while pending with nothing to serve).
   *
   * @generated from field: string lander_id = 3;
   */
  landerId = "";

  /**
   * @generated from field: string lander_name = 4;
   */
  landerName = "";

  /**
   * @generated from field: string category_key = 5;
   */
  categoryKey = "";

  /**
   * @generated from field: string category_title = 6;
   */
  categoryTitle = "";

  /**
   * @generated from field: string geo = 7;
   */
  geo = "";

  /**
   * @generated from field: string lang = 8;
   */
  lang = "";

  /**
   * @generated from field: google.protobuf.Timestamp assigned_at = 9;
   */
  assignedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp pending_since = 10;
   */
  pendingSince?: Timestamp;

  /**
   * Whites this campaign burned (moderation, bans, «заменить»).
   *
   * @generated from field: int32 burned_count = 11;
   */
  burnedCount = 0;

  /**
   * The white's current version, for the lander preview (/lander/{id}/?v=).
   *
   * @generated from field: int32 lander_version = 12;
   */
  landerVersion = 0;

  constructor(data?: PartialMessage<CampaignWhite>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignWhite";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "state", kind: "enum", T: proto3.getEnumType(CampaignWhiteState) },
    { no: 3, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lander_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "category_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "category_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "geo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "assigned_at", kind: "message", T: Timestamp },
    { no: 10, name: "pending_since", kind: "message", T: Timestamp },
    { no: 11, name: "burned_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "lander_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignWhite {
    return new CampaignWhite().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignWhite {
    return new CampaignWhite().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignWhite {
    return new CampaignWhite().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignWhite | PlainMessage<CampaignWhite> | undefined, b: CampaignWhite | PlainMessage<CampaignWhite> | undefined): boolean {
    return proto3.util.equals(CampaignWhite, a, b);
  }
}

/**
 * ContactProfile is sitegen.v1 ContactProfile as a category stores it: the
 * generator writes these strings as given. The tracker's default is its own
 * macros — {domain} is the host the lander is served on, filled at serve
 * time. A phone is never written.
 *
 * @generated from message tracker.v1.WhiteContactProfile
 */
export class WhiteContactProfile extends Message<WhiteContactProfile> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string email_template = 2;
   */
  emailTemplate = "";

  /**
   * @generated from field: string site_host = 3;
   */
  siteHost = "";

  /**
   * @generated from field: bool show_city_address = 4;
   */
  showCityAddress = false;

  /**
   * @generated from field: bool contact_form = 5;
   */
  contactForm = false;

  constructor(data?: PartialMessage<WhiteContactProfile>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.WhiteContactProfile";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email_template", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "show_city_address", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "contact_form", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WhiteContactProfile {
    return new WhiteContactProfile().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WhiteContactProfile {
    return new WhiteContactProfile().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WhiteContactProfile {
    return new WhiteContactProfile().fromJsonString(jsonString, options);
  }

  static equals(a: WhiteContactProfile | PlainMessage<WhiteContactProfile> | undefined, b: WhiteContactProfile | PlainMessage<WhiteContactProfile> | undefined): boolean {
    return proto3.util.equals(WhiteContactProfile, a, b);
  }
}

/**
 * @generated from message tracker.v1.WhiteCategory
 */
export class WhiteCategory extends Message<WhiteCategory> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Stable key the cabinet names ("joints"); never changes.
   *
   * @generated from field: string key = 2;
   */
  key = "";

  /**
   * @generated from field: string title = 3;
   */
  title = "";

  /**
   * The sitegen preset it orders from; "" = whites only come in as ZIPs.
   *
   * @generated from field: string preset_key = 4;
   */
  presetKey = "";

  /**
   * Offer tags whose offers take this category's whites.
   *
   * @generated from field: repeated string offer_tag_ids = 5;
   */
  offerTagIds: string[] = [];

  /**
   * @generated from field: tracker.v1.WhiteContactProfile contact_profile = 6;
   */
  contactProfile?: WhiteContactProfile;

  /**
   * A cell's daily target never goes below it.
   *
   * @generated from field: int32 target_min = 7;
   */
  targetMin = 0;

  /**
   * The fresh count at or below which a cell orders more at once.
   *
   * @generated from field: int32 reorder_at = 8;
   */
  reorderAt = 0;

  /**
   * @generated from field: bool enabled = 9;
   */
  enabled = false;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<WhiteCategory>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.WhiteCategory";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "preset_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "offer_tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "contact_profile", kind: "message", T: WhiteContactProfile },
    { no: 7, name: "target_min", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "reorder_at", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WhiteCategory {
    return new WhiteCategory().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WhiteCategory {
    return new WhiteCategory().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WhiteCategory {
    return new WhiteCategory().fromJsonString(jsonString, options);
  }

  static equals(a: WhiteCategory | PlainMessage<WhiteCategory> | undefined, b: WhiteCategory | PlainMessage<WhiteCategory> | undefined): boolean {
    return proto3.util.equals(WhiteCategory, a, b);
  }
}

/**
 * @generated from message tracker.v1.WhiteCell
 */
export class WhiteCell extends Message<WhiteCell> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string category_id = 2;
   */
  categoryId = "";

  /**
   * @generated from field: string category_key = 3;
   */
  categoryKey = "";

  /**
   * @generated from field: string geo = 4;
   */
  geo = "";

  /**
   * @generated from field: string lang = 5;
   */
  lang = "";

  /**
   * Fresh whites the cell should hold (nightly: 7 days' assignments/day × 1.5,
   * never below the category's target_min).
   *
   * @generated from field: int32 target = 6;
   */
  target = 0;

  /**
   * The effective threshold (the cell's own, else the category's).
   *
   * @generated from field: int32 reorder_at = 7;
   */
  reorderAt = 0;

  /**
   * true = reorder_at is the cell's own override.
   *
   * @generated from field: bool reorder_at_override = 8;
   */
  reorderAtOverride = false;

  /**
   * @generated from field: bool enabled = 9;
   */
  enabled = false;

  /**
   * @generated from field: int32 fresh = 10;
   */
  fresh = 0;

  /**
   * @generated from field: int32 assigned = 11;
   */
  assigned = 0;

  /**
   * @generated from field: int32 burned = 12;
   */
  burned = 0;

  /**
   * Sites on the way in open orders.
   *
   * @generated from field: int32 ordered = 13;
   */
  ordered = 0;

  /**
   * @generated from field: int32 open_orders = 14;
   */
  openOrders = 0;

  /**
   * @generated from field: int32 consumed_7d = 15;
   */
  consumed7d = 0;

  /**
   * Campaigns waiting for a white of this cell.
   *
   * @generated from field: int32 pending = 16;
   */
  pending = 0;

  /**
   * @generated from field: tracker.v1.WhiteCellColor color = 17;
   */
  color = WhiteCellColor.UNSPECIFIED;

  /**
   * @generated from field: google.protobuf.Timestamp target_computed_at = 18;
   */
  targetComputedAt?: Timestamp;

  constructor(data?: PartialMessage<WhiteCell>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.WhiteCell";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "geo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "reorder_at", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "reorder_at_override", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "fresh", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "assigned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "burned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "ordered", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "open_orders", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "consumed_7d", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "pending", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "color", kind: "enum", T: proto3.getEnumType(WhiteCellColor) },
    { no: 18, name: "target_computed_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WhiteCell {
    return new WhiteCell().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WhiteCell {
    return new WhiteCell().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WhiteCell {
    return new WhiteCell().fromJsonString(jsonString, options);
  }

  static equals(a: WhiteCell | PlainMessage<WhiteCell> | undefined, b: WhiteCell | PlainMessage<WhiteCell> | undefined): boolean {
    return proto3.util.equals(WhiteCell, a, b);
  }
}

/**
 * @generated from message tracker.v1.WhitePage
 */
export class WhitePage extends Message<WhitePage> {
  /**
   * @generated from field: string lander_id = 1;
   */
  landerId = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: tracker.v1.WhiteState state = 3;
   */
  state = WhiteState.UNSPECIFIED;

  /**
   * @generated from field: string geo = 4;
   */
  geo = "";

  /**
   * @generated from field: string lang = 5;
   */
  lang = "";

  /**
   * The sitegen generation it came from ("" = imported by hand).
   *
   * @generated from field: string generation_id = 6;
   */
  generationId = "";

  /**
   * @generated from field: string sha256 = 7;
   */
  sha256 = "";

  /**
   * @generated from field: string campaign_id = 8;
   */
  campaignId = "";

  /**
   * @generated from field: string campaign_name = 9;
   */
  campaignName = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp assigned_at = 11;
   */
  assignedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp burned_at = 12;
   */
  burnedAt?: Timestamp;

  /**
   * @generated from field: string burn_reason = 13;
   */
  burnReason = "";

  /**
   * The served version (preview: the lander preview of this version).
   *
   * @generated from field: int32 version = 14;
   */
  version = 0;

  constructor(data?: PartialMessage<WhitePage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.WhitePage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "state", kind: "enum", T: proto3.getEnumType(WhiteState) },
    { no: 4, name: "geo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "generation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "sha256", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "campaign_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "assigned_at", kind: "message", T: Timestamp },
    { no: 12, name: "burned_at", kind: "message", T: Timestamp },
    { no: 13, name: "burn_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WhitePage {
    return new WhitePage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WhitePage {
    return new WhitePage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WhitePage {
    return new WhitePage().fromJsonString(jsonString, options);
  }

  static equals(a: WhitePage | PlainMessage<WhitePage> | undefined, b: WhitePage | PlainMessage<WhitePage> | undefined): boolean {
    return proto3.util.equals(WhitePage, a, b);
  }
}

/**
 * @generated from message tracker.v1.WhiteRefill
 */
export class WhiteRefill extends Message<WhiteRefill> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string cell_id = 2;
   */
  cellId = "";

  /**
   * @generated from field: tracker.v1.WhiteRefillKind kind = 3;
   */
  kind = WhiteRefillKind.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.WhiteRefillState state = 4;
   */
  state = WhiteRefillState.UNSPECIFIED;

  /**
   * @generated from field: string sitegen_order_id = 5;
   */
  sitegenOrderId = "";

  /**
   * @generated from field: string campaign_id = 6;
   */
  campaignId = "";

  /**
   * @generated from field: int32 requested = 7;
   */
  requested = 0;

  /**
   * @generated from field: int32 ready = 8;
   */
  ready = 0;

  /**
   * @generated from field: int32 failed = 9;
   */
  failed = 0;

  /**
   * Sites taken into the pool.
   *
   * @generated from field: int32 ingested = 10;
   */
  ingested = 0;

  /**
   * @generated from field: string error = 11;
   */
  error = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp ordered_at = 13;
   */
  orderedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 14;
   */
  finishedAt?: Timestamp;

  constructor(data?: PartialMessage<WhiteRefill>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.WhiteRefill";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cell_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kind", kind: "enum", T: proto3.getEnumType(WhiteRefillKind) },
    { no: 4, name: "state", kind: "enum", T: proto3.getEnumType(WhiteRefillState) },
    { no: 5, name: "sitegen_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "requested", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "ready", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "failed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "ingested", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "created_at", kind: "message", T: Timestamp },
    { no: 13, name: "ordered_at", kind: "message", T: Timestamp },
    { no: 14, name: "finished_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WhiteRefill {
    return new WhiteRefill().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WhiteRefill {
    return new WhiteRefill().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WhiteRefill {
    return new WhiteRefill().fromJsonString(jsonString, options);
  }

  static equals(a: WhiteRefill | PlainMessage<WhiteRefill> | undefined, b: WhiteRefill | PlainMessage<WhiteRefill> | undefined): boolean {
    return proto3.util.equals(WhiteRefill, a, b);
  }
}

/**
 * @generated from message tracker.v1.WhitePreset
 */
export class WhitePreset extends Message<WhitePreset> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  /**
   * @generated from field: string title = 3;
   */
  title = "";

  /**
   * @generated from field: repeated string geos = 4;
   */
  geos: string[] = [];

  /**
   * @generated from field: repeated string langs = 5;
   */
  langs: string[] = [];

  constructor(data?: PartialMessage<WhitePreset>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.WhitePreset";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "geos", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "langs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WhitePreset {
    return new WhitePreset().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WhitePreset {
    return new WhitePreset().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WhitePreset {
    return new WhitePreset().fromJsonString(jsonString, options);
  }

  static equals(a: WhitePreset | PlainMessage<WhitePreset> | undefined, b: WhitePreset | PlainMessage<WhitePreset> | undefined): boolean {
    return proto3.util.equals(WhitePreset, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListWhiteCategoriesRequest
 */
export class ListWhiteCategoriesRequest extends Message<ListWhiteCategoriesRequest> {
  constructor(data?: PartialMessage<ListWhiteCategoriesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListWhiteCategoriesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWhiteCategoriesRequest {
    return new ListWhiteCategoriesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWhiteCategoriesRequest {
    return new ListWhiteCategoriesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWhiteCategoriesRequest {
    return new ListWhiteCategoriesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWhiteCategoriesRequest | PlainMessage<ListWhiteCategoriesRequest> | undefined, b: ListWhiteCategoriesRequest | PlainMessage<ListWhiteCategoriesRequest> | undefined): boolean {
    return proto3.util.equals(ListWhiteCategoriesRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListWhiteCategoriesResponse
 */
export class ListWhiteCategoriesResponse extends Message<ListWhiteCategoriesResponse> {
  /**
   * @generated from field: repeated tracker.v1.WhiteCategory categories = 1;
   */
  categories: WhiteCategory[] = [];

  constructor(data?: PartialMessage<ListWhiteCategoriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListWhiteCategoriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "categories", kind: "message", T: WhiteCategory, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWhiteCategoriesResponse {
    return new ListWhiteCategoriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWhiteCategoriesResponse {
    return new ListWhiteCategoriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWhiteCategoriesResponse {
    return new ListWhiteCategoriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWhiteCategoriesResponse | PlainMessage<ListWhiteCategoriesResponse> | undefined, b: ListWhiteCategoriesResponse | PlainMessage<ListWhiteCategoriesResponse> | undefined): boolean {
    return proto3.util.equals(ListWhiteCategoriesResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListWhitePresetsRequest
 */
export class ListWhitePresetsRequest extends Message<ListWhitePresetsRequest> {
  constructor(data?: PartialMessage<ListWhitePresetsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListWhitePresetsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWhitePresetsRequest {
    return new ListWhitePresetsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWhitePresetsRequest {
    return new ListWhitePresetsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWhitePresetsRequest {
    return new ListWhitePresetsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWhitePresetsRequest | PlainMessage<ListWhitePresetsRequest> | undefined, b: ListWhitePresetsRequest | PlainMessage<ListWhitePresetsRequest> | undefined): boolean {
    return proto3.util.equals(ListWhitePresetsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListWhitePresetsResponse
 */
export class ListWhitePresetsResponse extends Message<ListWhitePresetsResponse> {
  /**
   * What answers the sitegen port ("Загрузка вручную" when manual).
   *
   * @generated from field: string port_label = 1;
   */
  portLabel = "";

  /**
   * true = nothing generates: the pool only takes imported ZIPs.
   *
   * @generated from field: bool manual = 2;
   */
  manual = false;

  /**
   * @generated from field: repeated tracker.v1.WhitePreset presets = 3;
   */
  presets: WhitePreset[] = [];

  /**
   * The port checks imported ZIPs (extended "check").
   *
   * @generated from field: bool checks_imports = 4;
   */
  checksImports = false;

  constructor(data?: PartialMessage<ListWhitePresetsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListWhitePresetsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "port_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "manual", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "presets", kind: "message", T: WhitePreset, repeated: true },
    { no: 4, name: "checks_imports", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWhitePresetsResponse {
    return new ListWhitePresetsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWhitePresetsResponse {
    return new ListWhitePresetsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWhitePresetsResponse {
    return new ListWhitePresetsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWhitePresetsResponse | PlainMessage<ListWhitePresetsResponse> | undefined, b: ListWhitePresetsResponse | PlainMessage<ListWhitePresetsResponse> | undefined): boolean {
    return proto3.util.equals(ListWhitePresetsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateWhiteCategoryRequest
 */
export class CreateWhiteCategoryRequest extends Message<CreateWhiteCategoryRequest> {
  /**
   * @generated from field: tracker.v1.WhiteCategory category = 1;
   */
  category?: WhiteCategory;

  constructor(data?: PartialMessage<CreateWhiteCategoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateWhiteCategoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "category", kind: "message", T: WhiteCategory },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWhiteCategoryRequest {
    return new CreateWhiteCategoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWhiteCategoryRequest {
    return new CreateWhiteCategoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWhiteCategoryRequest {
    return new CreateWhiteCategoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWhiteCategoryRequest | PlainMessage<CreateWhiteCategoryRequest> | undefined, b: CreateWhiteCategoryRequest | PlainMessage<CreateWhiteCategoryRequest> | undefined): boolean {
    return proto3.util.equals(CreateWhiteCategoryRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateWhiteCategoryResponse
 */
export class CreateWhiteCategoryResponse extends Message<CreateWhiteCategoryResponse> {
  /**
   * @generated from field: tracker.v1.WhiteCategory category = 1;
   */
  category?: WhiteCategory;

  constructor(data?: PartialMessage<CreateWhiteCategoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateWhiteCategoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "category", kind: "message", T: WhiteCategory },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWhiteCategoryResponse {
    return new CreateWhiteCategoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWhiteCategoryResponse {
    return new CreateWhiteCategoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWhiteCategoryResponse {
    return new CreateWhiteCategoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWhiteCategoryResponse | PlainMessage<CreateWhiteCategoryResponse> | undefined, b: CreateWhiteCategoryResponse | PlainMessage<CreateWhiteCategoryResponse> | undefined): boolean {
    return proto3.util.equals(CreateWhiteCategoryResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateWhiteCategoryRequest
 */
export class UpdateWhiteCategoryRequest extends Message<UpdateWhiteCategoryRequest> {
  /**
   * id names it; key is kept as it is.
   *
   * @generated from field: tracker.v1.WhiteCategory category = 1;
   */
  category?: WhiteCategory;

  constructor(data?: PartialMessage<UpdateWhiteCategoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateWhiteCategoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "category", kind: "message", T: WhiteCategory },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWhiteCategoryRequest {
    return new UpdateWhiteCategoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWhiteCategoryRequest {
    return new UpdateWhiteCategoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWhiteCategoryRequest {
    return new UpdateWhiteCategoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWhiteCategoryRequest | PlainMessage<UpdateWhiteCategoryRequest> | undefined, b: UpdateWhiteCategoryRequest | PlainMessage<UpdateWhiteCategoryRequest> | undefined): boolean {
    return proto3.util.equals(UpdateWhiteCategoryRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateWhiteCategoryResponse
 */
export class UpdateWhiteCategoryResponse extends Message<UpdateWhiteCategoryResponse> {
  /**
   * @generated from field: tracker.v1.WhiteCategory category = 1;
   */
  category?: WhiteCategory;

  constructor(data?: PartialMessage<UpdateWhiteCategoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateWhiteCategoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "category", kind: "message", T: WhiteCategory },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWhiteCategoryResponse {
    return new UpdateWhiteCategoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWhiteCategoryResponse {
    return new UpdateWhiteCategoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWhiteCategoryResponse {
    return new UpdateWhiteCategoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWhiteCategoryResponse | PlainMessage<UpdateWhiteCategoryResponse> | undefined, b: UpdateWhiteCategoryResponse | PlainMessage<UpdateWhiteCategoryResponse> | undefined): boolean {
    return proto3.util.equals(UpdateWhiteCategoryResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteWhiteCategoryRequest
 */
export class DeleteWhiteCategoryRequest extends Message<DeleteWhiteCategoryRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteWhiteCategoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteWhiteCategoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteWhiteCategoryRequest {
    return new DeleteWhiteCategoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteWhiteCategoryRequest {
    return new DeleteWhiteCategoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteWhiteCategoryRequest {
    return new DeleteWhiteCategoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteWhiteCategoryRequest | PlainMessage<DeleteWhiteCategoryRequest> | undefined, b: DeleteWhiteCategoryRequest | PlainMessage<DeleteWhiteCategoryRequest> | undefined): boolean {
    return proto3.util.equals(DeleteWhiteCategoryRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteWhiteCategoryResponse
 */
export class DeleteWhiteCategoryResponse extends Message<DeleteWhiteCategoryResponse> {
  constructor(data?: PartialMessage<DeleteWhiteCategoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteWhiteCategoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteWhiteCategoryResponse {
    return new DeleteWhiteCategoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteWhiteCategoryResponse {
    return new DeleteWhiteCategoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteWhiteCategoryResponse {
    return new DeleteWhiteCategoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteWhiteCategoryResponse | PlainMessage<DeleteWhiteCategoryResponse> | undefined, b: DeleteWhiteCategoryResponse | PlainMessage<DeleteWhiteCategoryResponse> | undefined): boolean {
    return proto3.util.equals(DeleteWhiteCategoryResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListWhiteCellsRequest
 */
export class ListWhiteCellsRequest extends Message<ListWhiteCellsRequest> {
  constructor(data?: PartialMessage<ListWhiteCellsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListWhiteCellsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWhiteCellsRequest {
    return new ListWhiteCellsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWhiteCellsRequest {
    return new ListWhiteCellsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWhiteCellsRequest {
    return new ListWhiteCellsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWhiteCellsRequest | PlainMessage<ListWhiteCellsRequest> | undefined, b: ListWhiteCellsRequest | PlainMessage<ListWhiteCellsRequest> | undefined): boolean {
    return proto3.util.equals(ListWhiteCellsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListWhiteCellsResponse
 */
export class ListWhiteCellsResponse extends Message<ListWhiteCellsResponse> {
  /**
   * @generated from field: repeated tracker.v1.WhiteCell cells = 1;
   */
  cells: WhiteCell[] = [];

  /**
   * Over every cell.
   *
   * @generated from field: int32 fresh = 2;
   */
  fresh = 0;

  /**
   * @generated from field: int32 assigned = 3;
   */
  assigned = 0;

  /**
   * @generated from field: int32 burned = 4;
   */
  burned = 0;

  /**
   * @generated from field: int32 consumed_7d = 5;
   */
  consumed7d = 0;

  /**
   * Cells at or below their threshold now.
   *
   * @generated from field: int32 low_cells = 6;
   */
  lowCells = 0;

  /**
   * @generated from field: int32 pending_campaigns = 7;
   */
  pendingCampaigns = 0;

  /**
   * Sites ordered today (Kyiv), by kind.
   *
   * @generated from field: int32 ordered_today_night = 8;
   */
  orderedTodayNight = 0;

  /**
   * @generated from field: int32 ordered_today_day = 9;
   */
  orderedTodayDay = 0;

  /**
   * @generated from field: int32 ordered_today_urgent = 10;
   */
  orderedTodayUrgent = 0;

  constructor(data?: PartialMessage<ListWhiteCellsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListWhiteCellsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cells", kind: "message", T: WhiteCell, repeated: true },
    { no: 2, name: "fresh", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "assigned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "burned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "consumed_7d", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "low_cells", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "pending_campaigns", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "ordered_today_night", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "ordered_today_day", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "ordered_today_urgent", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWhiteCellsResponse {
    return new ListWhiteCellsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWhiteCellsResponse {
    return new ListWhiteCellsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWhiteCellsResponse {
    return new ListWhiteCellsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWhiteCellsResponse | PlainMessage<ListWhiteCellsResponse> | undefined, b: ListWhiteCellsResponse | PlainMessage<ListWhiteCellsResponse> | undefined): boolean {
    return proto3.util.equals(ListWhiteCellsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateWhiteCellRequest
 */
export class CreateWhiteCellRequest extends Message<CreateWhiteCellRequest> {
  /**
   * @generated from field: string category_id = 1;
   */
  categoryId = "";

  /**
   * @generated from field: string geo = 2;
   */
  geo = "";

  /**
   * @generated from field: string lang = 3;
   */
  lang = "";

  /**
   * Unset = the category's threshold.
   *
   * @generated from field: optional int32 reorder_at = 4;
   */
  reorderAt?: number;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled = false;

  constructor(data?: PartialMessage<CreateWhiteCellRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateWhiteCellRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "geo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "reorder_at", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWhiteCellRequest {
    return new CreateWhiteCellRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWhiteCellRequest {
    return new CreateWhiteCellRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWhiteCellRequest {
    return new CreateWhiteCellRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWhiteCellRequest | PlainMessage<CreateWhiteCellRequest> | undefined, b: CreateWhiteCellRequest | PlainMessage<CreateWhiteCellRequest> | undefined): boolean {
    return proto3.util.equals(CreateWhiteCellRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateWhiteCellResponse
 */
export class CreateWhiteCellResponse extends Message<CreateWhiteCellResponse> {
  /**
   * @generated from field: tracker.v1.WhiteCell cell = 1;
   */
  cell?: WhiteCell;

  constructor(data?: PartialMessage<CreateWhiteCellResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateWhiteCellResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cell", kind: "message", T: WhiteCell },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWhiteCellResponse {
    return new CreateWhiteCellResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWhiteCellResponse {
    return new CreateWhiteCellResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWhiteCellResponse {
    return new CreateWhiteCellResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWhiteCellResponse | PlainMessage<CreateWhiteCellResponse> | undefined, b: CreateWhiteCellResponse | PlainMessage<CreateWhiteCellResponse> | undefined): boolean {
    return proto3.util.equals(CreateWhiteCellResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateWhiteCellRequest
 */
export class UpdateWhiteCellRequest extends Message<UpdateWhiteCellRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Unset = the category's threshold.
   *
   * @generated from field: optional int32 reorder_at = 2;
   */
  reorderAt?: number;

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled = false;

  constructor(data?: PartialMessage<UpdateWhiteCellRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateWhiteCellRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reorder_at", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWhiteCellRequest {
    return new UpdateWhiteCellRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWhiteCellRequest {
    return new UpdateWhiteCellRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWhiteCellRequest {
    return new UpdateWhiteCellRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWhiteCellRequest | PlainMessage<UpdateWhiteCellRequest> | undefined, b: UpdateWhiteCellRequest | PlainMessage<UpdateWhiteCellRequest> | undefined): boolean {
    return proto3.util.equals(UpdateWhiteCellRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateWhiteCellResponse
 */
export class UpdateWhiteCellResponse extends Message<UpdateWhiteCellResponse> {
  /**
   * @generated from field: tracker.v1.WhiteCell cell = 1;
   */
  cell?: WhiteCell;

  constructor(data?: PartialMessage<UpdateWhiteCellResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateWhiteCellResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cell", kind: "message", T: WhiteCell },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWhiteCellResponse {
    return new UpdateWhiteCellResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWhiteCellResponse {
    return new UpdateWhiteCellResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWhiteCellResponse {
    return new UpdateWhiteCellResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWhiteCellResponse | PlainMessage<UpdateWhiteCellResponse> | undefined, b: UpdateWhiteCellResponse | PlainMessage<UpdateWhiteCellResponse> | undefined): boolean {
    return proto3.util.equals(UpdateWhiteCellResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCellWhitesRequest
 */
export class ListCellWhitesRequest extends Message<ListCellWhitesRequest> {
  /**
   * @generated from field: string cell_id = 1;
   */
  cellId = "";

  /**
   * UNSPECIFIED = every state.
   *
   * @generated from field: tracker.v1.WhiteState state = 2;
   */
  state = WhiteState.UNSPECIFIED;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit = 0;

  constructor(data?: PartialMessage<ListCellWhitesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCellWhitesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cell_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "state", kind: "enum", T: proto3.getEnumType(WhiteState) },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCellWhitesRequest {
    return new ListCellWhitesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCellWhitesRequest {
    return new ListCellWhitesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCellWhitesRequest {
    return new ListCellWhitesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCellWhitesRequest | PlainMessage<ListCellWhitesRequest> | undefined, b: ListCellWhitesRequest | PlainMessage<ListCellWhitesRequest> | undefined): boolean {
    return proto3.util.equals(ListCellWhitesRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListCellWhitesResponse
 */
export class ListCellWhitesResponse extends Message<ListCellWhitesResponse> {
  /**
   * @generated from field: repeated tracker.v1.WhitePage whites = 1;
   */
  whites: WhitePage[] = [];

  constructor(data?: PartialMessage<ListCellWhitesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListCellWhitesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "whites", kind: "message", T: WhitePage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCellWhitesResponse {
    return new ListCellWhitesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCellWhitesResponse {
    return new ListCellWhitesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCellWhitesResponse {
    return new ListCellWhitesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCellWhitesResponse | PlainMessage<ListCellWhitesResponse> | undefined, b: ListCellWhitesResponse | PlainMessage<ListCellWhitesResponse> | undefined): boolean {
    return proto3.util.equals(ListCellWhitesResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ImportWhiteRequest
 */
export class ImportWhiteRequest extends Message<ImportWhiteRequest> {
  /**
   * @generated from field: string cell_id = 1;
   */
  cellId = "";

  /**
   * The site as a ZIP (index.html at its root), at most 25 MiB.
   *
   * @generated from field: bytes zip = 2;
   */
  zip = new Uint8Array(0);

  /**
   * "" = named from the cell and the archive.
   *
   * @generated from field: string name = 3;
   */
  name = "";

  constructor(data?: PartialMessage<ImportWhiteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ImportWhiteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cell_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "zip", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportWhiteRequest {
    return new ImportWhiteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportWhiteRequest {
    return new ImportWhiteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportWhiteRequest {
    return new ImportWhiteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ImportWhiteRequest | PlainMessage<ImportWhiteRequest> | undefined, b: ImportWhiteRequest | PlainMessage<ImportWhiteRequest> | undefined): boolean {
    return proto3.util.equals(ImportWhiteRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ImportWhiteResponse
 */
export class ImportWhiteResponse extends Message<ImportWhiteResponse> {
  /**
   * @generated from field: tracker.v1.WhitePage white = 1;
   */
  white?: WhitePage;

  constructor(data?: PartialMessage<ImportWhiteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ImportWhiteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "white", kind: "message", T: WhitePage },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportWhiteResponse {
    return new ImportWhiteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportWhiteResponse {
    return new ImportWhiteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportWhiteResponse {
    return new ImportWhiteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ImportWhiteResponse | PlainMessage<ImportWhiteResponse> | undefined, b: ImportWhiteResponse | PlainMessage<ImportWhiteResponse> | undefined): boolean {
    return proto3.util.equals(ImportWhiteResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.RefillWhiteNowRequest
 */
export class RefillWhiteNowRequest extends Message<RefillWhiteNowRequest> {
  /**
   * @generated from field: string cell_id = 1;
   */
  cellId = "";

  constructor(data?: PartialMessage<RefillWhiteNowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.RefillWhiteNowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cell_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefillWhiteNowRequest {
    return new RefillWhiteNowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefillWhiteNowRequest {
    return new RefillWhiteNowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefillWhiteNowRequest {
    return new RefillWhiteNowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RefillWhiteNowRequest | PlainMessage<RefillWhiteNowRequest> | undefined, b: RefillWhiteNowRequest | PlainMessage<RefillWhiteNowRequest> | undefined): boolean {
    return proto3.util.equals(RefillWhiteNowRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.RefillWhiteNowResponse
 */
export class RefillWhiteNowResponse extends Message<RefillWhiteNowResponse> {
  /**
   * @generated from field: tracker.v1.WhiteRefill refill = 1;
   */
  refill?: WhiteRefill;

  constructor(data?: PartialMessage<RefillWhiteNowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.RefillWhiteNowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "refill", kind: "message", T: WhiteRefill },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefillWhiteNowResponse {
    return new RefillWhiteNowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefillWhiteNowResponse {
    return new RefillWhiteNowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefillWhiteNowResponse {
    return new RefillWhiteNowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RefillWhiteNowResponse | PlainMessage<RefillWhiteNowResponse> | undefined, b: RefillWhiteNowResponse | PlainMessage<RefillWhiteNowResponse> | undefined): boolean {
    return proto3.util.equals(RefillWhiteNowResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListWhiteRefillsRequest
 */
export class ListWhiteRefillsRequest extends Message<ListWhiteRefillsRequest> {
  /**
   * "" = every cell.
   *
   * @generated from field: string cell_id = 1;
   */
  cellId = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<ListWhiteRefillsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListWhiteRefillsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cell_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWhiteRefillsRequest {
    return new ListWhiteRefillsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWhiteRefillsRequest {
    return new ListWhiteRefillsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWhiteRefillsRequest {
    return new ListWhiteRefillsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWhiteRefillsRequest | PlainMessage<ListWhiteRefillsRequest> | undefined, b: ListWhiteRefillsRequest | PlainMessage<ListWhiteRefillsRequest> | undefined): boolean {
    return proto3.util.equals(ListWhiteRefillsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListWhiteRefillsResponse
 */
export class ListWhiteRefillsResponse extends Message<ListWhiteRefillsResponse> {
  /**
   * @generated from field: repeated tracker.v1.WhiteRefill refills = 1;
   */
  refills: WhiteRefill[] = [];

  constructor(data?: PartialMessage<ListWhiteRefillsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListWhiteRefillsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "refills", kind: "message", T: WhiteRefill, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWhiteRefillsResponse {
    return new ListWhiteRefillsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWhiteRefillsResponse {
    return new ListWhiteRefillsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWhiteRefillsResponse {
    return new ListWhiteRefillsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWhiteRefillsResponse | PlainMessage<ListWhiteRefillsResponse> | undefined, b: ListWhiteRefillsResponse | PlainMessage<ListWhiteRefillsResponse> | undefined): boolean {
    return proto3.util.equals(ListWhiteRefillsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.BurnWhiteRequest
 */
export class BurnWhiteRequest extends Message<BurnWhiteRequest> {
  /**
   * @generated from field: string lander_id = 1;
   */
  landerId = "";

  /**
   * @generated from field: string reason = 2;
   */
  reason = "";

  constructor(data?: PartialMessage<BurnWhiteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.BurnWhiteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BurnWhiteRequest {
    return new BurnWhiteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BurnWhiteRequest {
    return new BurnWhiteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BurnWhiteRequest {
    return new BurnWhiteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BurnWhiteRequest | PlainMessage<BurnWhiteRequest> | undefined, b: BurnWhiteRequest | PlainMessage<BurnWhiteRequest> | undefined): boolean {
    return proto3.util.equals(BurnWhiteRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.BurnWhiteResponse
 */
export class BurnWhiteResponse extends Message<BurnWhiteResponse> {
  /**
   * @generated from field: tracker.v1.WhitePage white = 1;
   */
  white?: WhitePage;

  constructor(data?: PartialMessage<BurnWhiteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.BurnWhiteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "white", kind: "message", T: WhitePage },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BurnWhiteResponse {
    return new BurnWhiteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BurnWhiteResponse {
    return new BurnWhiteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BurnWhiteResponse {
    return new BurnWhiteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BurnWhiteResponse | PlainMessage<BurnWhiteResponse> | undefined, b: BurnWhiteResponse | PlainMessage<BurnWhiteResponse> | undefined): boolean {
    return proto3.util.equals(BurnWhiteResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ReplaceWhiteRequest
 */
export class ReplaceWhiteRequest extends Message<ReplaceWhiteRequest> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * Why («не прошёл модерацию»); "" = «заменён».
   *
   * @generated from field: string reason = 2;
   */
  reason = "";

  constructor(data?: PartialMessage<ReplaceWhiteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ReplaceWhiteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReplaceWhiteRequest {
    return new ReplaceWhiteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReplaceWhiteRequest {
    return new ReplaceWhiteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReplaceWhiteRequest {
    return new ReplaceWhiteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReplaceWhiteRequest | PlainMessage<ReplaceWhiteRequest> | undefined, b: ReplaceWhiteRequest | PlainMessage<ReplaceWhiteRequest> | undefined): boolean {
    return proto3.util.equals(ReplaceWhiteRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ReplaceWhiteResponse
 */
export class ReplaceWhiteResponse extends Message<ReplaceWhiteResponse> {
  /**
   * @generated from field: tracker.v1.CampaignWhite white = 1;
   */
  white?: CampaignWhite;

  constructor(data?: PartialMessage<ReplaceWhiteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ReplaceWhiteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "white", kind: "message", T: CampaignWhite },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReplaceWhiteResponse {
    return new ReplaceWhiteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReplaceWhiteResponse {
    return new ReplaceWhiteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReplaceWhiteResponse {
    return new ReplaceWhiteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReplaceWhiteResponse | PlainMessage<ReplaceWhiteResponse> | undefined, b: ReplaceWhiteResponse | PlainMessage<ReplaceWhiteResponse> | undefined): boolean {
    return proto3.util.equals(ReplaceWhiteResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetCampaignWhiteRequest
 */
export class GetCampaignWhiteRequest extends Message<GetCampaignWhiteRequest> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  constructor(data?: PartialMessage<GetCampaignWhiteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetCampaignWhiteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCampaignWhiteRequest {
    return new GetCampaignWhiteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCampaignWhiteRequest {
    return new GetCampaignWhiteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCampaignWhiteRequest {
    return new GetCampaignWhiteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCampaignWhiteRequest | PlainMessage<GetCampaignWhiteRequest> | undefined, b: GetCampaignWhiteRequest | PlainMessage<GetCampaignWhiteRequest> | undefined): boolean {
    return proto3.util.equals(GetCampaignWhiteRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetCampaignWhiteResponse
 */
export class GetCampaignWhiteResponse extends Message<GetCampaignWhiteResponse> {
  /**
   * @generated from field: tracker.v1.CampaignWhite white = 1;
   */
  white?: CampaignWhite;

  constructor(data?: PartialMessage<GetCampaignWhiteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetCampaignWhiteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "white", kind: "message", T: CampaignWhite },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCampaignWhiteResponse {
    return new GetCampaignWhiteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCampaignWhiteResponse {
    return new GetCampaignWhiteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCampaignWhiteResponse {
    return new GetCampaignWhiteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCampaignWhiteResponse | PlainMessage<GetCampaignWhiteResponse> | undefined, b: GetCampaignWhiteResponse | PlainMessage<GetCampaignWhiteResponse> | undefined): boolean {
    return proto3.util.equals(GetCampaignWhiteResponse, a, b);
  }
}

